import React from 'react';
import { Box, Card, CardContent, Typography, Stack, Grid, Avatar, Divider } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { Navigate } from 'react-router-dom';
import TaskList from './TaskList';

function InfoRow({ icon, label, value }) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Avatar variant="rounded" sx={{ bgcolor: 'primary.main', width: 36, height: 36 }}>
        {icon}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" display="block">
          {label}
        </Typography>
        <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
          {value || '—'}
        </Typography>
      </Box>
    </Stack>
  );
}

export default function ClientPage() {
  const info = (() => {
    try { return JSON.parse(sessionStorage.getItem('companyInfo') || 'null'); }
    catch { return null; }
  })();
  if (!info) return <Navigate to="/login" replace />;

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Hoş geldin, <Box component="span" sx={{ color: 'primary.main' }}>{info.name}</Box>
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>Şirket Bilgileri</Typography>
              <Stack spacing={2}>
                <InfoRow icon={<BusinessIcon fontSize="small" />} label="Ünvan" value={info.fullname} />
                <InfoRow icon={<LocationOnIcon fontSize="small" />} label="Adres" value={info.address} />
                <Divider />
                <InfoRow icon={<EmailIcon fontSize="small" />} label="E-posta" value={info.mail} />
                <InfoRow icon={<PhoneIcon fontSize="small" />} label="Telefon" value={info.phone} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={7}>
          <TaskList />
        </Grid>
      </Grid>
    </Box>
  );
}
